import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useServicesList = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const getServicesList = async (clinicLocationId) => {
        // Fetch services list
        setLoading(true);
        try {
            const list = await apiService.servicesList(clinicLocationId);
            setLoading(false);
            list && setData(list); // update data state
            return list;
        } catch (error) {
            setLoading(false);
        }
    }

    return {
        data,
        loading,
        getServicesList,
    }
}